import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
// import { AnimatePresence } from "framer-motion";
import PublicRoute from "./PublicRoute";
import PageLoader from "@/components/PageLoader";

const VerifyToken = lazy(() =>
  import(/* webpackChunkName:'Expired Link' */ "@/components/VerifyToken")
);
const ExpiredLink = lazy(() =>
  import(/* webpackChunkName:'Expired Link' */ "@/components/ExpiredLink")
);
const Login = lazy(() =>
  import(/* webpackChunkName:'LoginPage' */ "@/pages/Login")
);
const ForgetPassword = lazy(() =>
  import(/* webpackChunkName:'ForgetPasswordPage' */ "@/pages/ForgetPassword")
);
const NotFound = lazy(() =>
  import(/* webpackChunkName:'NotFoundPage' */ "@/pages/NotFound")
);
const WaitingPage = lazy(() =>
  import(/* webpackChunkName:'WaitingPage' */ "@/pages/WaitingPage")
);

export default function AuthRouter() {
  const location = useLocation();

  return (
    <Suspense fallback={<PageLoader />}>
      {/* <AnimatePresence mode='wait' initial={false}> */}
      <Routes location={location} key={location.pathname}>
        {/* Public Routes */}
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/waiting-page" element={<WaitingPage />} />
          <Route path="/expired-link" element={<ExpiredLink />} />
          <Route path="/reset-password/:token" element={<ForgetPassword />} />
          <Route path="/onboarding/verify" element={<VerifyToken />} />
        </Route>

        {/* Not Found */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
      {/* </AnimatePresence> */}
    </Suspense>
  );
}
